import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Image, Loader2, MonitorPlay, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnPrimary, Skeleton } from "@/components/portal/ui";
import { AdminTitle } from "@/pages/admin/AdminLayout";

const FIELDS = [
  ["welcome_headline", "Judul Motion (mis. Welcome to Family)"],
  ["welcome_subheadline", "Sub Judul", "textarea"],
  ["welcome_interval", "Durasi tiap slide (detik)"],
  ["welcome_prayer_title", "Judul QR Prayer Request"],
  ["welcome_prayer_text", "Teks QR Prayer Request", "textarea"],
];

export default function WelcomeAdmin() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/public/site").then((r) => setS(r.data)); }, []);
  if (!s) return <Skeleton className="h-96" />;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/site", s);
      toast.success("Layar Sapa Jemaat diperbarui");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const screenUrl = `${window.location.origin}/welcome`;
  const prayUrl = `${window.location.origin}/pray`;

  return (
    <form onSubmit={save} data-testid="admin-welcome-screen">
      <AdminTitle eyebrow="Konten" title="Layar Sapa Jemaat">
        <a href="/welcome" target="_blank" rel="noreferrer" data-testid="welcome-open-button" className="inline-flex items-center gap-2 bg-slate-900 text-white rounded-xl px-4 py-2.5 text-sm font-bold"><MonitorPlay className="w-4 h-4" /> Buka Layar</a>
        <button disabled={busy} data-testid="welcome-save-button" className={btnPrimary}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Simpan"}</button>
      </AdminTitle>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-slate-100 space-y-4">
          <p className="font-extrabold text-slate-900">Teks & Durasi</p>
          {FIELDS.map(([k, label, type]) => (
            <label key={k} className="block">
              <span className="text-xs font-bold text-slate-500 uppercase tracking-wider">{label}</span>
              <div className="mt-2">
                {type === "textarea"
                  ? <textarea rows={3} className={inputCls} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`welcome-${k}`} />
                  : <input className={inputCls} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`welcome-${k}`} />}
              </div>
            </label>
          ))}
          <div className="rounded-2xl bg-slate-50 p-4 text-sm text-slate-600">
            <p className="font-bold text-slate-900">Slide otomatis berganti & looping:</p>
            <ul className="mt-2 space-y-1 list-disc pl-5 text-xs">
              <li>Motion sambutan (judul di atas)</li>
              <li>Jadwal ibadah mingguan (menu Jadwal Ibadah)</li>
              <li>Ibadah minggu ini (Event dengan "Tanpa registrasi")</li>
              <li>Foto ibadah (menu Galeri) & media khusus di bawah</li>
              <li>Coming up event (Event Khusus & agenda mendatang)</li>
            </ul>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-slate-100" data-testid="welcome-links">
            <p className="font-extrabold text-slate-900">Tautan Layar & QR Doa</p>
            <div className="mt-4 grid sm:grid-cols-2 gap-5 items-start">
              <div>
                <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Layar TV / Proyektor</p>
                <a href="/welcome" target="_blank" rel="noreferrer" className="mt-2 block text-sm font-bold text-blue-600 break-all">{screenUrl} <ExternalLink className="inline w-3.5 h-3.5" /></a>
                <p className="mt-2 text-xs text-slate-500">Buka di browser layar/TV, lalu tekan F11 (fullscreen).</p>
              </div>
              <div className="text-center">
                <div className="inline-block bg-white p-3 rounded-2xl border border-slate-100"><QRCodeSVG value={prayUrl} size={120} data-testid="welcome-pray-qr" /></div>
                <p className="mt-2 text-xs font-bold text-slate-600 flex items-center justify-center gap-1"><QrCode className="w-3.5 h-3.5" />Form doa mandiri</p>
                <a href="/pray" target="_blank" rel="noreferrer" className="text-[11px] text-blue-600 break-all">{prayUrl}</a>
              </div>
            </div>
          </div>
          <Link to="/admin/content/welcome_media" data-testid="welcome-media-link" className="block bg-slate-900 text-white rounded-3xl p-6 hover:-translate-y-0.5 transition">
            <Image className="w-6 h-6 text-blue-300" />
            <p className="mt-3 font-extrabold">Kelola Media Layar Sapa</p>
            <p className="text-xs text-white/60 mt-1">Tambah foto ibadah & video kegiatan (YouTube) yang tampil bergantian di layar.</p>
          </Link>
        </div>
      </div>
    </form>
  );
}
